class FortuneSavingRatioUrlPath {
    public static BASE = "/fortune/savingRatio";

    public static CREATE = FortuneSavingRatioUrlPath.BASE + "/create";
    public static UPDATE = FortuneSavingRatioUrlPath.BASE + "/update";
}

export default FortuneSavingRatioUrlPath;